import { Call } from '../../../utils/multicall'
import {
  buildSiloPairCalls,
  SILO_LENS_WORDS,
  usesSiloLens,
} from '../silo-v2/userCallBuild'
import { resolveSiloRoster } from '../silo-v2/roster'
import {
  getPositionLensFor,
  LENS_FAMILY,
  PositionLensAbi,
} from '../position-lens'
import { encodeAbiParameters, parseAbiParameters } from 'viem'

export const SILO_V3_USER_CALLS_PER_SIDE = 5
export const SILO_V3_USER_CALLS_PER_PAIR = SILO_V3_USER_CALLS_PER_SIDE * 2

export { SILO_LENS_WORDS, usesSiloLens }

/**
 * Silo v3 reads exactly like v2 — same five calls per side, same share tokens,
 * same `convertToAssets(uint256,uint8)` — and the deployed lens serves both from
 * one family for the same reason: the shapes are identical, only the registry slot
 * the roster comes from differs. Sharing the builders keeps it that way; two copies
 * would drift the moment one side gained a field.
 */
export const buildSiloV3UserCall = (
  chainId: string,
  lender: string,
  account: string,
  params?: any,
): Call[] => {
  const roster = resolveSiloRoster(chainId, lender, params)
  if (roster.length === 0) return []

  const lens = getPositionLensFor(chainId, LENS_FAMILY.SILO)
  if (lens) {
    const side = (h: any) => [
      h.silo,
      h.protectedShareToken,
      h.debtShareToken,
      Number(h.decimals),
    ]
    const payload = encodeAbiParameters(
      parseAbiParameters(
        '((address,address,address,uint8),(address,address,address,uint8))[]',
      ),
      [roster.map((r) => [side(r.market.silo0), side(r.market.silo1)]) as any],
    )
    return [
      {
        address: lens,
        name: 'getUserData',
        params: [[{ family: LENS_FAMILY.SILO, payload }], account],
        abi: PositionLensAbi as any,
      },
    ]
  }
  return roster.flatMap((r) => buildSiloPairCalls(r.market, account))
}
